<template>
    <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
        <span class="alert-danger">У вас нет доступа к этой странице.</span>
    </div>
    <div class="main-content bg-white" v-else-if="$currentUser.role != 'account'">
        <div class="page-header">
            <h3 class="page-title">Настраиваемый отчет</h3>
        </div>
        <div v-if="isMobile">
            <div class="col-lg-12">
                <b>Сохранённые шаблоны</b>
                <div v-if="templates.length == 0">У вас нет сохранённых шаблонов.</div>
                <b-list-group>
                    <div v-if="templates.length > 0" v-for="template in templates">
                        <b-list-group-item>
                            <div class="d-flex w-100 justify-content-between">
                                <div>
                                    <span>{{template.title}}</span>
                                    <span> ({{template.date_from | formatDate}} - {{template.date_to | formatDate}})</span>
                                </div>
                                <b-button-group style="height: 30px">
                                    <a class="btn btn-outline-success btn-sm "
                                       v-bind:href="getExcelParamsStringMobile('xlsx', template.params_string)">Excel</a>
                                    <a class="btn btn-outline-success btn-sm"
                                       v-bind:href="getExcelParamsStringMobile('csv', template.params_string)">CSV</a>
                                </b-button-group>
                            </div>
                        </b-list-group-item>
                    </div>
                </b-list-group>
            </div>
        </div>
        <div v-if="!isMobile" class="row mb-2">
            <!--<div class="col-lg-12">-->
            <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                <b-button-group :key="dateRange" v-if="isXl" class="datePickerXl filterComponent">
                    <date-range-picker
                            ref="picker"
                            :locale-data="dateRangeLocalFormat"
                            v-model="range"
                            :opens="'right'"
                            :ranges="dateRanges"
                            @update="selectRange($event)">
                        <template v-slot:input="picker" style="min-width: 350px;!important;">
                            {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                        </template>
                    </date-range-picker>
                    <b-button size="sm" variant="primary">
                        <i class="icon-fa icon-fa-calendar-check-o"></i>
                    </b-button>
                </b-button-group>

                <b-input-group :key="dateRange" v-if="!isXl" class="filterComponent">
                    <div></div>
                    <b-input-group-append>
                        <datepicker input-class="form-control dateFrom"
                                    class="date dateLeft"
                                    monday-first
                                    size="sm"
                                    v-model="range.startDate"
                                    :language="ru"
                                    placeholder="С:">
                        </datepicker>
                        <datepicker input-class="form-control dateTo"
                                    class="date dateRight"
                                    size="sm"
                                    monday-first
                                    v-model="range.endDate"
                                    :language="ru"
                                    placeholder="По:">
                        </datepicker>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-btn size="sm" class="mb-2 mainButton" text="Search" variant="outline-success"
                       :class="showCollapse1 ? 'collapsed' : null"
                       :aria-expanded="showCollapse1 ? 'true' : 'false'"
                       aria-controls="collapse-1"
                       @click="onClick(1)">
                    Колонки
                    <span v-if="showCollapse1"><i class="icon-fa icon-fa-minus"></i></span>
                    <span v-if="!showCollapse1"><i class="icon-fa icon-fa-plus"></i></span>
                </b-btn>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-button variant="outline-success" size="sm"
                          class="mb-2 mainButton"
                          :class="showCollapse2 ? 'collapsed' : null"
                          :aria-expanded="showCollapse2 ? 'true' : 'false'"
                          aria-controls="collapse-3"
                          @click="onClick(2)">
                    Фильтры
                    <span v-if="showCollapse2"><i class="icon-fa icon-fa-minus"></i></span>
                    <span v-if="!showCollapse2"><i class="icon-fa icon-fa-plus"></i></span>
                </b-button>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-button variant="outline-success" size="sm"
                          class="mb-2 mainButton"
                          :class="showCollapse3 ? 'collapsed' : null"
                          :aria-expanded="showCollapse3 ? 'true' : 'false'"
                          aria-controls="collapse-3"
                          @click="onClick(3)">
                    Шаблоны
                    <span v-if="showCollapse3"><i class="icon-fa icon-fa-minus"></i></span>
                    <span v-if="!showCollapse3"><i class="icon-fa icon-fa-plus"></i></span>
                </b-button>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-btn size="sm" class="mainButton mb-2" text="Search" variant="success"
                       @click="confirmSettings()">
                    Сформировать
                </b-btn>
            </div>
        </div>
        <div v-if="!isMobile" class="row">
            <div class="col-lg-12">
                <b-collapse id="collapse-1" v-model="showCollapse1" class="mt-2">
                    <b-card>
                        <div class="row mb-3">
                            <div class="col-lg-12">
                                <h3 style="color: #6c757d !important;">Выберите данные:</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.date.value" name="check-button">
                                    <b>{{columns.date.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2  col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.date_month.value" name="check-button">
                                    <b>{{columns.date_month.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.user.value" name="check-button">
                                    <b>{{columns.user.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                              <b-form-checkbox v-model="columns.sales_managers.value" name="check-button">
                                <b>{{columns.sales_managers.label}}</b>
                              </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                              <b-form-checkbox v-model="columns.account_manager_name.value" name="check-button">
                                <b>{{columns.account_manager_name.label}}</b>
                              </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.partner_id.value" name="check-button">
                                    <b>{{columns.partner_id.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.offer_title.value" name="check-button">
                                    <b>{{columns.offer_title.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.type.value" name="check-button">
                                    <b>{{columns.type.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.affise_platform.value" name="check-button">
                                    <b>{{columns.affise_platform.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.affise_id.value" name="check-button">
                                    <b>{{columns.affise_id.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.offer_id.value" name="check-button">
                                    <b>{{columns.offer_id.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.advertiser.value" name="check-button">
                                    <b>{{columns.advertiser.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.sub1.value" name="check-button">
                                    <b>{{columns.sub1.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.sub2.value" name="check-button">
                                    <b>{{columns.sub2.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.sub3.value" name="check-button">
                                    <b>{{columns.sub3.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.sub4.value" name="check-button">
                                    <b>{{columns.sub4.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.platforms.value" name="check-button">
                                    <b>{{columns.platforms.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.tracker.value" name="check-button">
                                    <b>{{columns.tracker.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                              <b-form-checkbox v-model="columns.channel.value" name="check-button">
                                <b>{{columns.channel.label}}</b>
                              </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.source_title.value" name="check-button">
                                    <b>{{columns.source_title.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.source_group.value" name="check-button">
                                    <b>{{columns.source_group.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3"
                                 v-if="this.$currentUser.department === 'adkey'">
                              <b-form-checkbox v-model="columns.application_owner.value" name="check-button">
                                <b>{{columns.application_owner.label}}</b>
                              </b-form-checkbox>
                            </div>
                          <div class="col-lg-2 col-md-3 col-sm-3">
                            <b-form-checkbox v-model="columns.responsibleBuyer.value" name="check-button">
                              <b>{{columns.responsibleBuyer.label}}</b>
                            </b-form-checkbox>
                          </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.is_test.value" name="check-button">
                                    <b>{{columns.is_test.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <div class="row mt-4 mb-3">
                            <div class="col-lg-12">
                                <h3 style="color: #6c757d !important;">Выберите расчёты:</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.expense_currency.value" name="check-button">
                                    <b>{{columns.expense.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.expense_usd.value" name="check-button">
                                    <b>{{columns.expense_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.avg_expense_rate.value" name="check-button">
                                    <b>{{columns.avg_expense_rate.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.expense_with_discount_usd.value" name="check-button">
                                    <b>{{columns.expense_with_discount_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.discount_usd.value" name="check-button">
                                    <b>{{columns.discount_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.leads_count.value" name="check-button">
                                    <b>{{columns.leads_count.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.lead_rate_usd.value" name="check-button">
                                    <b>{{columns.lead_rate_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.lead_rate.value" name="check-button">
                                    <b>{{columns.lead_rate.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.lead_currency.value" name="check-button">
                                    <b>{{columns.revenue.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.avg_revenue_rate.value" name="check-button">
                                    <b>{{columns.avg_revenue_rate.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.revenue_usd.value" name="check-button">
                                    <b>{{columns.revenue_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.profit.value" name="check-button">
                                    <b>{{columns.profit.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.roi.value" name="check-button">
                                    <b>{{columns.roi.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.gm_rev.value" name="check-button">
                                    <b>{{columns.gm_rev.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.revenue_conversions.value" name="check-button">
                                    <b>{{columns.revenue_conversions.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.revenue_conversions_usd.value" name="check-button">
                                    <b>{{columns.revenue_conversions_usd.label}}</b>
                                </b-form-checkbox>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-3">
                                <b-form-checkbox v-model="columns.gm.value" name="check-button">
                                    <b>{{columns.gm.label}}</b>
                                </b-form-checkbox>
                            </div>
                        </div>
                    </b-card>
                </b-collapse>

                <b-collapse id="collapse-2" v-model="showCollapse2" class="mt-2">
                    <b-card>
                        <div class="row mb-2">
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2"
                                 v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                                <v-select label="name" :options="users" required v-model="user" placeholder="Медиабайер"
                                          multiple>
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="selectOffers" :filter="filterOffers" required label="title"
                                          v-model="search"
                                          placeholder="Оффер"
                                          multiple>
                                    <span slot="no-options">Совпадений не найдено.</span>
                                    <template slot="option" slot-scope="option">
                                        <span>({{option.id}}) {{ option.title }}</span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="sources" :filter="filterSources" required label="title"
                                          v-model="source"
                                          placeholder="Источник"
                                          multiple>
                                    <span slot="no-options">Совпадений не найдено.</span>
                                    <template slot="option" slot-scope="option">
                                        <span>({{option.id}}) {{ option.title }}</span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="groups" required v-model="group" placeholder="Группа" multiple>
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="trackers"
                                          multiple
                                          placeholder="Трекер"
                                          v-model="selectedTracker">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="currency"
                                          placeholder="Валюта расхода"
                                          class="insertInput"
                                          v-model="selectedExpenseCurrency">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="currency"
                                          placeholder="Валюта дохода"
                                          class="insertInput"
                                          v-model="selectedRevenueCurrency">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="affisePlatforms" placeholder="Аффайз платформа"
                                          v-model="selectedAffisePlatform">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="platforms" placeholder="Платформа" required
                                          v-model="selectedPlatforms"
                                          multiple>
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="isTestOptions"
                                          :searchable="false"
                                          :clearable="false"
                                          v-model="isTest"
                                          placeholder="Тест">
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2"
                                 v-if="this.$currentUser.department === 'adkey'">
                              <v-select :options="applicationOwnerOptions"
                                        placeholder="Приложение"
                                        :clearable="false"
                                        :searchable="false"
                                        v-model="application_owner">
                              </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select :options="types"
                                          placeholder="Тип"
                                          :clearable="false"
                                          :searchable="false"
                                          multiple
                                          v-model="type">
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <b-form-input class="insertInput"
                                              type="text"
                                              style="height: 35px;"
                                              placeholder="Subid-1"
                                              v-model="selectedSub1">
                                </b-form-input>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <b-form-input class="insertInput"
                                              type="text"
                                              style="height: 35px;"
                                              placeholder="Subid-2"
                                              v-model="selectedSub2">
                                </b-form-input>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <b-form-input class="insertInput"
                                              type="text"
                                              style="height: 35px;"
                                              placeholder="Subid-3"
                                              v-model="selectedSub3">
                                </b-form-input>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                              <v-select :options="sub4Options"
                                        placeholder="Subid-4"
                                        label="text"
                                        style="height: 35px;"
                                        :clearable="false"
                                        :searchable="false"
                                        v-model="selectedSub4">
                              </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <b-form-input class="insertInput"
                                              type="text"
                                              style="height: 35px;"
                                              placeholder="ID партнёра"
                                              v-model="selectedPartnerId">
                                </b-form-input>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                              <v-select
                                placeholder="Сейл"
                                label="name"
                                :options="salesManagers"
                                :reduce="manager => manager.id"
                                multiple
                                v-model="selectedSalesManagers">
                                <span slot="no-options">Совпадений не найдено.</span>
                              </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                              <v-select
                                placeholder="Аккаунт"
                                label="name"
                                :options="accountManagers"
                                :reduce="accountManager => accountManager.id"
                                multiple
                                v-model="selectedAccountManagers">
                                <span slot="no-options">Совпадений не найдено.</span>
                              </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                                <v-select
                                  :options="advertisers"
                                  placeholder="Рекламодатель"
                                  :reduce="advertiser => advertiser.value"
                                  multiple
                                  v-model="selectedAdvertiser">
                                  <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                              <v-select :options="channels"
                                        placeholder="Канал продаж"
                                        :clearable="false"
                                        :searchable="false"
                                        :reduce="channel => channel.value"
                                        multiple
                                        v-model="channel">
                              </v-select>
                            </div>
                          <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <v-select :options="userGroups"
                                      label="title"
                                      placeholder="Группа пользователей"
                                      :clearable="false"
                                      :searchable="false"
                                      :reduce="userGroup => userGroup.id"
                                      multiple
                                      v-model="selectedUserGroups">
                            </v-select>
                          </div>
                        </div>
                    </b-card>
                </b-collapse>
                <b-collapse id="collapse-3" v-model="showCollapse3" class="mt-2">
                    <b-card>
                        <div class="row">
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-lg-12 mb-2">
                                        <b>Сохранить шаблон отчёта</b>
                                    </div>
                                    <div class="col-lg-12 mb-2">
                                        <div>Введите уникальное название отчёта:</div>
                                    </div>
                                    <div class="col-lg-12 mb-2">
                                        <b-form-input placeholder="Название:"
                                                      class="col-sm-10"
                                                      size="sm"
                                                      v-model="newTemplateTitle"></b-form-input>
                                        <span class=" alert-danger" v-if="submitted && !newTemplateTitle">Введите название шаблона.</span>
                                    </div>
                                    <div class="col-lg-12 mb-2">
                                        <div>Период отчёта: {{range.startDate | formatDate}} - {{range.endDate | formatDate}}
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <b-btn size="sm" variant="success" class="mr-2 mb-2"
                                               @click="saveTemplate()">
                                            Сохранить
                                        </b-btn>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8">
                                <div class="row">
                                    <div class="col-lg-12 mb-2">
                                        <b>Сохранённые шаблоны</b>
                                    </div>
                                    <div class="col-lg-12">
                                        <div v-if="templates.length == 0">У вас нет сохранённых шаблонов.</div>
                                        <div v-if="templates.length > 0" v-for="template in templates">
                                            <div class="mb-3">
                                                {{template.title}} ({{template.date_from | formatDate}} -
                                                {{template.date_to
                                                |
                                                formatDate}})
                                                <b-btn size="sm" variant="outline-warning" class="ml-3 mr-3"
                                                       @click.stop="getTemplate(template.params_string)">
                                                    Применить
                                                    <i class="icon-fa icon-fa-spinner"></i>
                                                </b-btn>
                                                <b-btn size="sm" variant="outline-danger"
                                                       @click.stop="deleteTemplate(template.id)">
                                                    Удалить
                                                    <i class="icon-fa icon-fa-trash-o"></i>
                                                </b-btn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-collapse>
            </div>
        </div>
        <div class="row" v-if="!isMobile">
            <div class="col-sm-8 col-md-9 col-lg-10 col-xl-10 mb-2">
                <h4>Период: {{range.startDate | formatDate}} - {{range.endDate | formatDate}}</h4>
            </div>
            <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
                <b-button-group class="mb-2 float-right">
                    <a class="btn btn-outline-success btn-sm" v-bind:href="getExcelParamsString('xlsx')">Excel</a>
                    <a class="btn btn-outline-success btn-sm"
                       v-bind:href="getExcelParamsString('csv')">CSV</a>
                </b-button-group>
            </div>
        </div>
        <div class="row" v-if="!isMobile">
            <div class="col-sm-12">
                <div v-if="!reports" class="text-danger">Выберите колонки.</div>
                <div v-if="reports">
                    <b-table hover responsive bordered
                             small
                             :items="reports"
                             :fields="customFields"
                             no-local-sorting
                             :sort-by.sync="sortBy"
                             @sort-changed="getReports(1, $event, user, search)"
                             :busy="isBusy"
                             :sort-desc.sync="sortDesc"
                             :sort-direction="sortDirection">
                        <template slot="table-busy">
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Загрузка...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(date)="row">
                            <div>{{row.item.date | formatDate}}</div>
                        </template>
                        <template v-slot:cell(type)="row">
                            <div v-if="row.item.type">
                               {{getOfferTypeByValue(row.item.type)}}
                            </div>
                        </template>
                        <template v-slot:cell(application_owner)="row">
                            <div v-if="row.item.application_owner">
                              {{getAppOwnerByValue(row.item.application_owner)}}
                            </div>
                        </template>
                        <template v-slot:cell(date_month)="row">
                            <div>{{row.item.date_month | formatMonth}}</div>
                        </template>
                        <template v-slot:cell(user)="row">
                            <div>{{row.item.user}} {{row.item.network_partner_id}}</div>
                        </template>
                        <template v-slot:cell(roi)="row">
                            <div v-if="row.item.roi !== null">{{row.item.roi}}</div>
                            <div v-if="row.item.roi === null">0.00</div>
                        </template>
                        <template v-slot:cell(gm_rev)="row">
                            <div v-if="row.item.gm_rev !== null">{{row.item.gm_rev}}</div>
                            <div v-if="row.item.gm_rev === null">0.00</div>
                        </template>
                        <template v-slot:cell(avg_expense_rate)="row">
                            <div v-if="row.item.avg_expense_rate !== null">{{row.item.avg_expense_rate}}</div>
                            <div v-if="row.item.avg_expense_rate === null">0.00</div>
                        </template>
                        <template v-slot:cell(avg_revenue_rate)="row">
                            <div v-if="row.item.avg_revenue_rate !== null">{{row.item.avg_revenue_rate}}</div>
                            <div v-if="row.item.avg_revenue_rate === null">0.00</div>
                        </template>
                        <template v-slot:cell(platforms)="row">
                            <div v-if="!row.item.offer">{{row.item.platforms | shield}}</div>
                            <div v-if="row.item.offer">
                                <div v-for="item in row.item.offer.platforms">
                                    <span>{{item}} </span>
                                </div>
                            </div>
                        </template>
                        <template v-slot:cell(is_test)="row">
                            <div v-if="row.item.is_test == 0">Нет</div>
                            <div v-if="row.item.is_test == 1">Да</div>
                        </template>
                        <template v-slot:cell(revenue_conversions)="row">
                            <div v-if="row.item.revenue_conversions !== null">{{row.item.revenue_conversions}} {{row.item.conversions_currency}}</div>
                            <div v-if="row.item.revenue_conversions === null">0.00</div>
                        </template>
                        <template v-slot:cell(revenue_conversions_usd)="row">
                            <div v-if="row.item.revenue_conversions_usd !== null">{{row.item.revenue_conversions_usd}}</div>
                            <div v-if="row.item.revenue_conversions_usd === null">0.00</div>
                        </template>
                        <template v-slot:cell(gm)="row">
                            <div v-if="row.item.gm !== null">{{row.item.gm}}</div>
                            <div v-if="row.item.gm === null">0.00</div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="row" v-if="!isMobile">
            <div class="col-lg-6 col-sm-6">
                <div class="" role="status" aria-live="polite">Количество строк:
                    <b-form-select v-model="pageSize"
                                   style="width: 70px;"
                                   v-on:change="getReports()"
                                   size="sm">
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="75">75</option>
                        <option :value="100">100</option>
                        <option :value="150">150</option>
                        <option :value="200">200</option>
                    </b-form-select>
                </div>
                <div class="" role="status" aria-live="polite">Записей на странице: <span
                        v-if="reports && reports.length">{{ reports.length - 2 }}</span><span v-if="!reports">0</span>
                </div>
                <div class="" role="status" aria-live="polite">Всего записей: <span v-if="pager && pager.total">{{ pager.total }}</span><span
                        v-if="!pager || !pager.total">0</span></div>
            </div>
            <div class="col-sm-6 col-lg-6">
                <div class="float-right">
                    <nav aria-label="Page navigation">
                        <ul class="pagination justify-content-center">
                            <b-pagination size="sm" :total-rows="pager.total"
                                          v-model="pager.current_page"
                                          v-on:change="getReports($event, {sortBy: sortBy, sortDesc: sortDesc}, user, search)"
                                          :per-page="pager.per_page"></b-pagination>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import OffersService from '../../services/offersDataService'
    import SourcesService from '../../services/sourcesDataService'
    import ReportsService from '../../services/reportsDataService'
    import Ls from '../../services/ls'
    import moment from 'moment'
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'
    import reportMixin from "./mixins/reportMixin";
    import advertiserFormMixin from "./mixins/Advertiser/advertiserFormMixin";
    import salesManagerFormMixin from "./mixins/SalesManager/salesManagerFormMixin";
    import accountManagerFormMixin from "./mixins/AccountManager/accountManagerFormMixin";
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'
    import dataOptionsMixin from "./mixins/dataOptionsMixin";

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";
    import UsersService from "../../services/usersDataService";

    export default {
        name: 'customReportComponent',
        components: {
            Datepicker: Datepicker,
            DateRangePicker: DateRangePicker
        },
        mixins: [
            reportMixin,
            advertiserFormMixin,
            salesManagerFormMixin,
            accountManagerFormMixin,
            saveFiltersMixin,
            vue2DateRangePickerMixin,
            dataOptionsMixin
        ],
        filters: {
            formatDate: function (value) {
                if (value) {
                    if (value != 'Итого по странице:' && value != 'Итого:') {
                        return moment(new Date(value)).locale('ru').format('D MMM YYYY')
                    } else {
                        return value;
                    }
                }
            },
            formatMonth: function (value) {
                if (value) {
                    if (value != 'Итого по странице:' && value != 'Итого:') {
                        value = value.toString()
                        let year = value.substring(0, 4)
                        let month = value.substring(4, 6)
                        let stringDate = year + '-' + month + '-' + '01';

                        return moment(new Date(stringDate)).locale('ru').format('MMM YYYY')
                    } else {
                        return value;
                    }
                }
            },
            shield: function (value) {
                if (value == '["i') {

                    return 'iOS'
                }
                if (value == '["w') {

                    return 'webOS'
                }
                if (value == '["A') {

                    return 'Android'
                }
            }
        },
        data() {
            return {
                isBusy: true,
                sources: [],
                group: [],
                pager: {},
                source: [],
                userGroups: [],
                isTestOptions: [
                    {value: 0, label: 'Не тест'},
                    {value: 1, label: 'Тест'},
                    {value: null, label: 'Все данные'},
                ],
                isTest: {value: 0, label: 'Не тест'},
                affisePlatforms: [],
                platforms: [],
                trackers: [],
                selectedUserGroups: [],
                channels: [
                  {
                    label: 'Конференция',
                    value: 'conference'
                  },
                  {
                    label: 'Нетворкинг',
                    value: 'networking'
                  },
                  {
                    label: 'Рекомендация',
                    value: 'recommendation'
                  },
                  {
                    label: 'Холодные продажи',
                    value: 'coldsale'
                  },
                  {
                    label: 'Запрос через сайт/соц.сети',
                    value: 'website'
                  }
                ],

                selectedPartnerId: '',
                selectedAdvertiser: [],
                selectedSalesManagers: [],
                selectedAccountManagers: [],
                channel: [],
                selectedSub1: '',
                selectedSub2: '',
                selectedSub3: '',
                selectedSub4: '',
                user: this.$currentUser.role == 'leader' ? [this.$currentUser] : null,
                users: [],
                reports: [],
                groups: [],
                selectedExpenseCurrency: '',
                selectedRevenueCurrency: '',
                submitted: false,
                columns: {
                    date: {
                        label: 'Дата (дни)',
                        value: false
                    },
                    date_month: {
                        label: 'Дата (месяца)',
                        value: false
                    },
                    user: {
                        label: 'Mедиабайер',
                        value: false
                    },
                    sales_managers: {
                        label: 'Сейлы',
                        value: false
                    },
                    account_manager_name: {
                      label: 'Аккаунт',
                      value: false
                    },
                    partner_id: {
                        label: 'ID партнёра',
                        value: false
                    },
                    offer_title: {
                        label: 'Оффер',
                        value: true
                    },
                    type: {
                        label: 'Тип',
                        value: false
                    },
                    application_owner: {
                        label: 'Владелец приложения',
                        value: false
                    },
                    responsibleBuyer: {
                      label: 'Ответственный МБ',
                      value: false
                    },
                    affise_platform: {
                        label: 'Affise',
                        value: false
                    },
                    affise_id: {
                        key: 'date',
                        label: 'Offer\'s Affise ID',
                        value: false
                    },
                    offer_id: {
                        label: 'ID оффера',
                        value: false
                    },
                    advertiser: {
                        label: 'Рекламодатель',
                        value: false
                    },
                    sub1: {
                        label: 'Subid-1',
                        value: false
                    },
                    sub2: {
                        key: 'date',
                        label: 'Subid-2',
                        value: false
                    },
                    sub3: {
                        label: 'Subid-3',
                        value: false
                    },
                    sub4: {
                        key: 'date',
                        label: 'Subid-4',
                        value: false
                    },
                    platforms: {
                        label: 'Платформа',
                        value: false
                    },
                    tracker: {
                        label: 'Трекер',
                        value: false
                    },
                    channel: {
                      label: 'Канал продаж',
                      value: false
                    },
                    source_title: {
                        label: 'Источник',
                        value: false
                    },
                    source_group: {
                        label: 'Группа источника',
                        value: false
                    },
                    is_test: {
                        label: 'Тест',
                        value: false
                    },
                    expense: {
                        label: 'Расход в исходной валюте',
                        value: false
                    },
                    expense_currency: {
                        label: 'Валюта исходного расхода',
                        value: false
                    },
                    expense_usd: {
                        label: 'Расход без скидки,$',
                        value: false
                    },
                    avg_expense_rate: {
                        label: 'Ср.курс расхода',
                        value: false
                    },
                    expense_with_discount_usd: {
                        label: 'Расход со скидкой,$',
                        value: true
                    },
                    discount_usd: {
                        label: 'Сумма скидки,$',
                        value: false
                    },
                    leads_count: {
                        label: 'Кол-во лидов',
                        value: false
                    },
                    lead_rate_usd: {
                        label: 'Ставка,$',
                        value: false
                    },
                    lead_rate: {
                        label: 'Ставка в исходной валюте',
                        value: false
                    },
                    revenue: {
                        label: 'Доход в исходной валюте',
                        value: false
                    },
                    lead_currency: {
                        label: 'Валюта исходного дохода/ставки',
                        value: false
                    },
                    revenue_usd: {
                        label: 'Доход,$',
                        value: true
                    },
                    avg_revenue_rate: {
                        label: 'Ср.курс дохода',
                        value: false
                    },
                    profit: {
                        label: 'Прибыль,$',
                        value: true
                    },
                    roi: {
                        label: 'ROI,%',
                        value: true
                    },
                    gm_rev: {
                        label: 'GM/REV,%',
                        value: true
                    },
                    revenue_conversions: {
                        label: 'Ревенью в исходной валюте',
                        value: false
                    },
                    revenue_conversions_usd: {
                        label: 'Ревенью,$',
                        value: false
                    },
                    gm: {
                        label: 'GM,$',
                        value: false
                    }
                },
                selectedColumns: [
                    'offer_title', 'expense_with_discount_usd', 'revenue_usd', 'profit', 'roi'
                ],
                customFields: [],
                search: [],
                format: 'xlsx',
                sortBy: null,
                sortDesc: true,
                sortDirection: 'desc',
                selectedAffisePlatform: [],
                selectedPlatforms: [],
                selectedTracker: [],
                pageSize: 25,
                previousFilterValues: {},
                month: new Date(Date.UTC(new Date().getMonth(), 0, 0)).getMonth(),
                selectedSource: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                selectOffers: [],
                showCollapse1: false,
                showCollapse2: false,
                showCollapse3: false,
                currency: [],
                newTemplateTitle: null,
                templates: [],
                isXl: false,
                ru: ru,
                savedFiltersName: 'custom-report',
            }
        },
        methods: {
            getTemplate(params) {
                this.isBusy = true;

                ReportsService.showTemplate(params)
                    .then(function (response) {
                        //set default page size
                        this.pageSize = 25;
                        let columns = this.getArrayParamsValue('columns', params);

                        //set all default columns values
                        this.columns = this.setDefaultColumns()

                        //remove unneeded columns
                        for (const [key, value] of Object.entries(this.columns)) {
                            if (columns.indexOf(key) < 0) {
                                this.columns[key].value = false
                            } else {
                                this.columns[key].value = true
                            }
                        }

                        this.applyFields();
                        this.setTemplateFilters(params);

                        this.pager = response.reports;
                        this.reports = response.reports.data

                        if (!this.reports) {
                            this.isBusy = false;

                            return;
                        }

                        let sumValues = ReportsService.getSumValues(this.reports)
                        let firstColumnsName = this.customFields[0].key;

                        let customRaw = {
                            expense_with_discount_usd: sumValues.sumExpenseWithDiscountUsd,
                            revenue_usd: sumValues.sumRevenueUsd,
                            leads_count: sumValues.sumLeadsCount,
                            profit: sumValues.sumProfit,
                            expense_usd: sumValues.sumExpenseUsd,
                            roi: sumValues.sumRoi,
                            gm_rev: sumValues.sumGmRev,
                            discount_usd: sumValues.sumDiscount,
                            gm: sumValues.sumGm,
                            revenue_conversions_usd: sumValues.sumRevenueUsdConversions,
                            _rowVariant: 'secondary'
                        };

                        let customSecondRaw = {
                            firstColumnsName: 'Итого:',
                            expense_with_discount_usd: response.sumValues.length > 0 && response.sumValues[0].expense_with_discount_usd ? response.sumValues[0].expense_with_discount_usd : 0.00,
                            revenue_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_usd ? response.sumValues[0].revenue_usd : 0.00,
                            profit: response.sumValues.length > 0 && response.sumValues[0].profit ? response.sumValues[0].profit : 0.00,
                            leads_count: response.sumValues.length > 0 && response.sumValues[0].leads_count ? response.sumValues[0].leads_count : 0,
                            expense_usd: response.sumValues.length > 0 && response.sumValues[0].expense_usd ? response.sumValues[0].expense_usd : 0.00,
                            roi: response.sumValues.length > 0 && response.sumValues[0].roi ? response.sumValues[0].roi : 0.00,
                            gm_rev: response.sumValues.length > 0 && response.sumValues[0].gm_rev ? response.sumValues[0].gm_rev : 0.00,
                            discount_usd: response.sumValues.length > 0 && response.sumValues[0].discount_usd ? response.sumValues[0].discount_usd : 0.00,
                            gm: response.sumValues.length > 0 && response.sumValues[0].gm ? response.sumValues[0].gm : 0.00,
                            revenue_conversions_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_conversions_usd ? response.sumValues[0].revenue_conversions_usd : 0.00,
                            _rowVariant: 'secondary'
                        };

                        customRaw[firstColumnsName] = 'Итого по странице:';
                        customSecondRaw[firstColumnsName] = 'Итого:';


                        let filtersObject = this.prepareFiltersObject(1, {sortBy: null, sortDesc: true}, this.search, this.user)

                        this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                        this.reports.push(customRaw)
                        this.reports.push(customSecondRaw)
                        this.isBusy = false;
                    }.bind(this))
            },
            saveTemplate() {
                this.submitted = true;

                if (this.newTemplateTitle) {
                    this.confirmSettings();

                    ReportsService.saveTemplate(this.selectedColumns, this.previousFilterValues, this.newTemplateTitle)
                        .then(function (response) {
                            this.submitted = false;
                            this.newTemplateTitle = null;
                            this.templates = response.templates
                        }.bind(this))
                }
            },
            setFilters() {
                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                let searchArray = [];

                if (this.search.length > 0) {
                    this.search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                this.previousFilterValues = {
                    userArray: userArray,
                    sourceArray: sourceArray,
                    searchArray: searchArray,
                    range: range,
                    isTest: this.isTest.value,
                    group: this.group,
                    selectedExpenseCurrency: this.selectedExpenseCurrency,
                    selectedRevenueCurrency: this.selectedRevenueCurrency,
                    selectedAffisePlatform: this.selectedAffisePlatform,
                    selectedPlatforms: this.selectedPlatforms,
                    selectedTracker: this.selectedTracker,
                    selectedPartnerId: this.selectedPartnerId,
                    selectedAdvertiser: this.selectedAdvertiser,
                    selectedSub1: this.selectedSub1,
                    selectedSub2: this.selectedSub2,
                    selectedSub3: this.selectedSub3,
                    selectedSub4: this.selectedSub4,
                    type: this.getCurrentOfferTypes(),
                    application_owner: this.application_owner.value,
                    salesManagers: this.selectedSalesManagers,
                    accountManagers: this.selectedAccountManagers,
                    channel: this.channel,
                    selectedUserGroups: this.selectedUserGroups
                }
            },
            setTemplateFilters(params) {
                //set users
                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    let templateUsers = this.getArrayParamsValue('user', params);

                    this.user = [];
                    this.users.forEach(function (user) {
                        if (templateUsers.indexOf(user.id.toString()) > -1) {
                            this.user.push(user)
                        }
                    }.bind(this))
                }

                //set sources
                let templateSources = this.getArrayParamsValue('source', params);

                this.source = [];
                this.sources.forEach(function (source) {
                    if (templateSources.indexOf(source.id.toString()) > -1) {
                        this.source.push(source)
                    }
                }.bind(this))

                //set offers
                let templateOffers = this.getArrayParamsValue('search', params);

                this.search = [];
                this.selectOffers.forEach(function (offer) {
                    if (templateOffers.indexOf(offer.id.toString()) > -1) {
                        this.search.push(offer)
                    }
                }.bind(this))

                //set isTest
                if (this.getParamsValue('isTest', params) == '0') {
                    this.isTest = {
                        label: 'Не тест',
                        value: 0
                    };
                } else if (this.getParamsValue('isTest', params) == '1') {
                    this.isTest = {
                        label: 'Тест',
                        value: 1
                    };
                } else {
                    this.isTest = {
                        label: 'Все данные',
                        value: null
                    };
                }

                this.application_owner = this.applicationOwnerOptions.find(
                  (option) => {
                    let value  = this.getParamsValue('application_owner', params)
                    if(value === ''){
                      value = null
                    }
                    return option.value === value
                  }
                )
                let range = {
                    startDate: this.getParamsValue('start', params),
                    endDate: this.getParamsValue('end', params)
                }

                //set date range
                let startN = new Date(range.startDate);
                let endN = new Date(range.endDate);

                this.range.startDate = startN
                this.range.endDate = endN

                //set another params
                this.group = this.getArrayParamsValue('group', params);
                this.selectedExpenseCurrency = this.getParamsValue('selectedExpenseCurrency', params);
                this.selectedRevenueCurrency = this.getParamsValue('selectedRevenueCurrency', params);
                this.selectedAffisePlatform = this.getParamsValue('selectedAffisePlatform', params);
                this.selectedPlatforms = this.getArrayParamsValue('selectedPlatforms', params);
                this.selectedTracker = this.getArrayParamsValue('selectedTracker', params);
                this.selectedPartnerId = this.getParamsValue('selectedPartnerId', params);
                this.selectedAdvertiser = this.getArrayParamsValue('selectedAdvertiser', params).map((value) => Number.parseInt(value));
                this.selectedSalesManagers = this.getArrayParamsValue('salesManagers', params).map((value) => Number.parseInt(value))
                this.selectedAccountManagers = this.getArrayParamsValue('accountManagers', params).map((value) => Number.parseInt(value))
                this.selectedSub1 = this.getParamsValue('selectedSub1', params);
                this.selectedSub2 = this.getParamsValue('selectedSub2', params);
                this.selectedSub3 = this.getParamsValue('selectedSub3', params);
                this.selectedSub4 = this.getParamsValue('selectedSub4', params);
                this.channel = this.getArrayParamsValue('channel', params);
                // this.type.value = this.getParamsValue('type', params);
                this.selectedUserGroups = this.getArrayParamsValue('selectedUserGroups', params).map((value) => Number.parseInt(value))


                this.type = [];
                let typesFromDb = this.getParamsValue('type', params).split(',');
                if(typesFromDb[0] !== '') {
                  typesFromDb.forEach((type) => {
                    this.type.push(
                      this.types.find((option) => option.value === type))
                  })
                }


                this.setFilters()
            },
            getParamsValue(param, params) {
                let value = params.match(param + '=([^&]+)')
                if (value) {
                    if (value[1] !== 'null' && value[1] !== 'undefined') {
                        return value[1];
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            },
            getArrayParamsValue(param, params) {
                let value = params.match(param + '=([^&]+)')
                if (value) {
                    return value[1].split(',');
                } else {
                    return [];
                }
            },
            getUserGroups() {
              let sort = {
                sortBy: null,
                sortDesc: null
              }

              UsersService.getUserGroups(sort)
                  .then(userGroups => {
                    this.userGroups = userGroups;
                  })
            },
            getReports(page, sort, user, search, isFilter) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        this.passFilters(filters)

                        page = filters.page
                        sort = filters.sort
                        user = filters.user
                        search = filters.search

                        this.applyFields()
                        this.setFilters()
                    }
                }


                //show spinner
                if (isFilter) {
                    this.isBusy = true;
                }
                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }

                let filtersObject = this.prepareFiltersObject(page, sort, search, user)

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                ReportsService.getCustomReport(page, sort, this.pageSize, this.selectedColumns, this.previousFilterValues)
                    .then(function (response) {
                        if (response) {
                            this.useSavedFilters = false
                            this.pager = response.reports;
                            this.reports = response.reports.data

                            if (!this.reports) {
                                this.isBusy = false;

                                return;
                            }

                            this.reports.forEach(function (report) {
                                var channelsLabels = {
                                    'conference': 'Конференция',
                                    'networking': 'Нетворкинг',
                                    'recommendation': 'Рекомендация',
                                    'coldsale': 'Холодные продажи',
                                    'website': 'Запрос через сайт/соц.сети'
                                };
                                if (report.channel != '') {
                                    report.channel = channelsLabels[report.channel];
                                }
                            });

                            let sumValues = ReportsService.getSumValues(this.reports)
                            let firstColumnsName = this.customFields[0].key;

                            let customRaw = {
                                expense_with_discount_usd: sumValues.sumExpenseWithDiscountUsd,
                                revenue_usd: sumValues.sumRevenueUsd,
                                leads_count: sumValues.sumLeadsCount,
                                profit: sumValues.sumProfit,
                                expense_usd: sumValues.sumExpenseUsd,
                                roi: sumValues.sumRoi,
                                gm_rev: sumValues.sumGmRev,
                                discount_usd: sumValues.sumDiscount,
                                gm: sumValues.sumGm,
                                revenue_conversions_usd: sumValues.sumRevenueUsdConversions,
                                _rowVariant: 'secondary'
                            };

                            let customSecondRaw = {
                                firstColumnsName: 'Итого:',
                                expense_with_discount_usd: response.sumValues.length > 0 && response.sumValues[0].expense_with_discount_usd ? response.sumValues[0].expense_with_discount_usd : 0.00,
                                revenue_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_usd ? response.sumValues[0].revenue_usd : 0.00,
                                profit: response.sumValues.length > 0 && response.sumValues[0].profit ? response.sumValues[0].profit : 0.00,
                                leads_count: response.sumValues.length > 0 && response.sumValues[0].leads_count ? response.sumValues[0].leads_count : 0,
                                expense_usd: response.sumValues.length > 0 && response.sumValues[0].expense_usd ? response.sumValues[0].expense_usd : 0.00,
                                roi: response.sumValues.length > 0 && response.sumValues[0].roi ? response.sumValues[0].roi : 0.00,
                                gm_rev: response.sumValues.length > 0 && response.sumValues[0].gm_rev ? response.sumValues[0].gm_rev : 0.00,
                                discount_usd: response.sumValues.length > 0 && response.sumValues[0].discount_usd ? response.sumValues[0].discount_usd : 0.00,
                                gm: response.sumValues.length > 0 && response.sumValues[0].gm ? response.sumValues[0].gm : 0.00,
                                revenue_conversions_usd: response.sumValues.length > 0 && response.sumValues[0].revenue_conversions_usd ? response.sumValues[0].revenue_conversions_usd : 0.00,
                                _rowVariant: 'secondary'
                            };

                            customRaw[firstColumnsName] = 'Итого по странице:';
                            customSecondRaw[firstColumnsName] = 'Итого:';

                            this.reports.push(customRaw)
                            this.reports.push(customSecondRaw)
                            this.isBusy = false;
                        }
                    }.bind(this))
            },
            prepareFiltersObject(page, sort, search, user) {
                let object = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    pageSize: this.pageSize,
                    range: this.previousFilterValues.range,
                    selectedColumns: this.selectedColumns,
                    user: this.user,
                    source: this.source,
                    search: this.search,
                    isTest: this.isTest,
                    group: this.group,
                    selectedExpenseCurrency: this.selectedExpenseCurrency,
                    selectedRevenueCurrency: this.selectedRevenueCurrency,
                    selectedAffisePlatform: this.selectedAffisePlatform,
                    selectedPlatforms: this.selectedPlatforms,
                    selectedTracker: this.selectedTracker,
                    selectedPartnerId: this.selectedPartnerId,
                    selectedAdvertiser: this.selectedAdvertiser,
                    selectedSub1: this.selectedSub1,
                    selectedSub2: this.selectedSub2,
                    selectedSub3: this.selectedSub3,
                    selectedSub4: this.selectedSub4,
                    type: this.type,
                    application_owner: this.application_owner,
                    selectedSalesManagers: this.selectedSalesManagers,
                    selectedAccountManagers: this.selectedAccountManagers,
                    channel: this.channel,
                    selectedUserGroups: this.selectedUserGroups
                }

                return object;
            },
            passFilters(filters) {
                for (const [key, value] of Object.entries(filters)) {
                    this[key] = value
                }
                this.range = this.dateConvert(filters.range.startDate, filters.range.endDate)


                let columns = this.selectedColumns;

                //set all default columns values
                this.columns = this.setDefaultColumns()

                //remove unneeded columns
                for (const [key, value] of Object.entries(this.columns)) {
                    if (columns.indexOf(key) < 0) {
                        this.columns[key].value = false
                    } else {
                        this.columns[key].value = true
                    }
                }

                this.applyFields();
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                    }.bind(this))
            },
            getTemplates() {
                ReportsService.getTemplates()
                    .then(function (response) {
                        this.templates = response;
                    }.bind(this))
            },
            deleteTemplate(id) {
                ReportsService.deleteTemplate(id)
                    .then(function (response) {
                        this.templates = response;
                    }.bind(this))
            },
            getExcelParamsString(format) {
                format = format ? format : this.format

                let AUTH_TOKEN = Ls.get('auth.token')

                return '/reports/export?subject=custom&sortBy='
                    + this.sortBy + '&sortDesc='
                    + this.sortDesc + '&start='
                    + this.previousFilterValues.range.startDate + '&end='
                    + this.previousFilterValues.range.endDate + '&user='
                    + this.previousFilterValues.userArray + '&search='
                    + this.previousFilterValues.searchArray + '&group='
                    + this.previousFilterValues.group + '&source='
                    + this.previousFilterValues.sourceArray + '&format='
                    + format + '&token=' + AUTH_TOKEN + '&isTest='
                    + this.previousFilterValues.isTest
                    + '&selectedExpenseCurrency=' + this.previousFilterValues.selectedExpenseCurrency
                    + '&selectedRevenueCurrency=' + this.previousFilterValues.selectedRevenueCurrency
                    + '&selectedAffisePlatform=' + this.previousFilterValues.selectedAffisePlatform
                    + '&selectedTracker=' + this.previousFilterValues.selectedTracker
                    + '&selectedPartnerId=' + this.previousFilterValues.selectedPartnerId
                    + '&selectedAdvertiser=' + this.previousFilterValues.selectedAdvertiser
                    + '&selectedSub1=' + this.previousFilterValues.selectedSub1
                    + '&selectedSub2=' + this.previousFilterValues.selectedSub2
                    + '&selectedSub3=' + this.previousFilterValues.selectedSub3
                    + '&selectedSub4=' + this.previousFilterValues.selectedSub4.value
                    + '&type=' + this.previousFilterValues.type
                    + '&application_owner=' + this.previousFilterValues.application_owner
                    + '&salesManagers=' + this.previousFilterValues.salesManagers
                    + '&accountManagers=' + this.previousFilterValues.accountManagers
                    + '&channel=' + this.previousFilterValues.channel
                    + '&columns=' + this.selectedColumns
                    + '&selectedUserGroups=' + this.previousFilterValues.selectedUserGroups;
            },
            getExcelParamsStringMobile(format, params) {
                format = format ? format : this.format

                let AUTH_TOKEN = Ls.get('auth.token')

                return '/reports/export?subject=custom&format='
                    + format + '&token=' + AUTH_TOKEN + '&' + params;
            },
            selectRange(event) {
                this.range = event;
            },
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {

                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
                            || option.id.toString().indexOf(search.toString()) >= 0
                            || option.affise_id && option.affise_id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            filterSources(options, search) {
                if (search) {
                    return options.filter(option => {

                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
                            || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getLeaderUsers() {
                OffersService.getLeaderUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getSources() {
                ReportsService.getSourcesForSelect()
                    .then(function (response) {
                        this.sources = response
                    }.bind(this))
            },
            getGroups() {
                SourcesService.getGroups()
                    .then(function (groups) {
                        this.groups = groups;
                    }.bind(this))
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                this.isMobile = this.window.width < 576;
                this.isXl = this.window.width > 992;
            },
            onClick(dropdownId) {
                let currentDropdown = 'showCollapse' + dropdownId;
                let firstDropdown = 'showCollapse1';
                let secondDropdown = 'showCollapse2';
                let thirdDropdown = 'showCollapse3';

                if (currentDropdown != firstDropdown) {
                    this[firstDropdown] = false;
                }
                if (currentDropdown != secondDropdown) {
                    this[secondDropdown] = false;
                }
                if (currentDropdown != thirdDropdown) {
                    this[thirdDropdown] = false;
                }

                this[currentDropdown] = this[currentDropdown] ? false : true;
            },
            confirmSettings() {
                this.showCollapse1 = false;
                this.showCollapse2 = false;
                this.showCollapse3 = false;
                this.sortBy = null;

                this.applyFields();
                this.setFilters();

                this.getReports(1, {
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc
                }, this.user, this.search, true)
            },
            applyFields() {
                let checkedColumnsNames = [];

                for (const [key, value] of Object.entries(this.columns)) {
                    if (value.value) {
                        checkedColumnsNames.push(key)

                        //because 1 checkbox for 2 columns
                        if (key == 'expense_currency') {
                            checkedColumnsNames.push('expense')
                        }
                        //because 1 checkbox for 2 columns
                        if (key == 'lead_currency') {
                            checkedColumnsNames.push('revenue')
                        }
                        //because 1 checkbox for 2 columns
                        if (key == 'lead_rate') {
                            checkedColumnsNames.push('lead_currency')
                            checkedColumnsNames.push('lead_rate')
                        }
                    }
                }

                //set to default columns. important for columns order.
                //update table
                this.customFields = this.setDefaultFields();

                let fields = [];

                this.customFields.forEach(function (item, index) {
                    if (checkedColumnsNames.indexOf(item.key) > -1) {
                        fields.push(item)
                    }
                }.bind(this))

                this.customFields = fields;

                this.selectedColumns = checkedColumnsNames;
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            getAffisePlatforms() {
                OffersService.getAffisePlatforms()
                    .then(function (response) {

                        this.affisePlatforms = response;
                    }.bind(this))
            },
            getPlatforms() {
                OffersService.getPlatforms()
                    .then(function (response) {

                        this.platforms = response;
                    }.bind(this))
            },
            getTrackers() {
                OffersService.getTrackers()
                    .then(function (response) {

                        this.trackers = response;
                        this.trackers.push('Без трекера')
                    }.bind(this))
            },

            setDefaultFields() {
                return [
                    {
                        key: 'date',
                        label: 'Дата (дни)',
                        sortable: true
                    },
                    {
                        key: 'date_month',
                        label: 'Дата (месяца)',
                        sortable: true
                    },
                    {
                        key: 'user',
                        label: 'Mедиабайер',
                        sortable: true
                    },
                    {
                      key: 'sales_managers',
                      label: 'Сейлы',
                      sortable: true,
                    },
                    {
                      key: 'account_manager_name',
                      label: 'Аккаунт',
                      sortable: true,
                    },
                    {
                        key: 'partner_id',
                        label: 'ID партнёра',
                        sortable: true
                    },
                    {
                        key: 'offer_title',
                        label: 'Оффер',
                        sortable: true
                    },
                    {
                        key: 'type',
                        label: 'Тип',
                        sortable: true
                    },
                    {
                      key: 'application_owner',
                      label: 'Приложение',
                      sortable: true
                    },
                    {
                      key: 'responsibleBuyer',
                      label: 'Ответственный МБ',
                      sortable: true
                    },
                    {
                        key: 'affise_platform',
                        label: 'Affise',
                        sortable: true
                    },
                    {
                        key: 'affise_id',
                        label: 'Offer\'s Affise ID',
                        sortable: true
                    },
                    {
                        key: 'offer_id',
                        label: 'ID оффера',
                        sortable: true
                    },
                    {
                        key: 'advertiser',
                        label: 'Рекламодатель',
                        sortable: true
                    },
                    {
                        key: 'sub1',
                        label: 'Subid-1',
                        sortable: true
                    },
                    {
                        key: 'sub2',
                        label: 'Subid-2',
                        sortable: true
                    },
                    {
                        key: 'sub3',
                        label: 'Subid-3',
                        sortable: true
                    },
                    {
                        key: 'sub4',
                        label: 'Subid-4',
                        sortable: true
                    },
                    {
                        key: 'platforms',
                        label: 'Платформа',
                        sortable: true
                    },
                    {
                        key: 'tracker',
                        label: 'Трекер',
                        sortable: true
                    },
                    {
                      key: 'channel',
                      label: 'Канал продаж',
                      sortable: true
                    },
                    {
                        key: 'source_title',
                        label: 'Источник',
                        sortable: true
                    },
                    {
                        key: 'source_group',
                        label: 'Группа источника',
                        sortable: true
                    },
                    {
                        key: 'is_test',
                        label: 'Тест',
                        sortable: true
                    },
                    {
                        key: 'expense',
                        label: 'Расход в исходной валюте',
                        sortable: true
                    },
                    {
                        key: 'expense_currency',
                        label: 'Валюта исходного расхода',
                        sortable: true
                    },
                    {
                        key: 'expense_usd',
                        label: 'Расход без скидки,$',
                        sortable: true
                    },
                    {
                        key: 'avg_expense_rate',
                        label: 'Ср.курс расхода',
                        sortable: true
                    },
                    {
                        key: 'expense_with_discount_usd',
                        label: 'Расход со скидкой,$',
                        sortable: true
                    },
                    {
                        key: 'discount_usd',
                        label: 'Сумма скидки,$',
                        sortable: true
                    },
                    {
                        key: 'leads_count',
                        label: 'Кол-во лидов',
                        sortable: true
                    },
                    {
                        key: 'lead_rate_usd',
                        label: 'Ставка,$',
                        sortable: true
                    },
                    {
                        key: 'lead_rate',
                        label: 'Ставка в исходной валюте',
                        sortable: true
                    },
                    {
                        key: 'revenue',
                        label: 'Доход в исходной валюте',
                        sortable: true
                    },
                    {
                        key: 'lead_currency',
                        label: 'Валюта исходного дохода/ставки',
                        sortable: true
                    },
                    {
                        key: 'revenue_usd',
                        label: 'Доход,$',
                        sortable: true
                    },
                    {
                        key: 'avg_revenue_rate',
                        label: 'Ср.курс дохода',
                        sortable: true
                    },
                    {
                        key: 'profit',
                        label: 'Прибыль,$',
                        sortable: true
                    },
                    {
                        key: 'roi',
                        label: 'ROI,%',
                        sortable: true
                    },
                    {
                        key: 'gm_rev',
                        label: 'GM/REV,%',
                        sortable: true
                    },
                    {
                        key: 'revenue_conversions',
                        label: 'Ревенью в исходной валюте',
                        sortable: false
                    },
                    {
                        key: 'revenue_conversions_usd',
                        label: 'Ревенью,$',
                        sortable: true
                    },
                    {
                        key: 'gm',
                        label: 'GM,$',
                        sortable: true
                    },
                ];
            },
            setDefaultColumns() {
                return {
                    date: {
                        label: 'Дата (дни)',
                        value: false
                    },
                    date_month: {
                        label: 'Дата (месяца)',
                        value: false
                    },
                    user: {
                        label: 'Mедиабайер',
                        value: false
                    },
                    sales_managers: {
                        label: 'Сейлы',
                        value: false,
                    },
                    account_manager_name: {
                      label: 'Аккаунт',
                      value: false,
                    },
                    partner_id: {
                        label: 'ID партнёра',
                        value: false
                    },
                    offer_title: {
                        label: 'Оффер',
                        value: true
                    },
                    type: {
                        label: 'Тип',
                        value: false
                    },
                    application_owner: {
                      label: 'Приложение',
                      value: false
                    },
                    responsibleBuyer: {
                      label: 'Ответственный МБ',
                      value: false
                    },
                    affise_platform: {
                        label: 'Affise',
                        value: false
                    },
                    affise_id: {
                        label: 'Offer\'s Affise ID',
                        value: false
                    },
                    offer_id: {
                        label: 'ID оффера',
                        value: false
                    },
                    advertiser: {
                        label: 'Рекламодатель',
                        value: false
                    },
                    sub1: {
                        label: 'Subid-1',
                        value: false
                    },
                    sub2: {
                        label: 'Subid-2',
                        value: false
                    },
                    sub3: {
                        label: 'Subid-3',
                        value: false
                    },
                    sub4: {
                        label: 'Subid-4',
                        value: false
                    },
                    platforms: {
                        label: 'Платформа',
                        value: false
                    },
                    tracker: {
                        label: 'Трекер',
                        value: false
                    },
                    channel: {
                      label: 'Канал продаж',
                      value: false
                    },
                    source_title: {
                        label: 'Источник',
                        value: false
                    },
                    source_group: {
                        label: 'Группа источника',
                        value: false
                    },
                    is_test: {
                        label: 'Тест',
                        value: false
                    },
                    expense: {
                        label: 'Расход в исходной валюте',
                        value: false
                    },
                    expense_currency: {
                        label: 'Валюта исходного расхода',
                        value: false
                    },
                    expense_usd: {
                        label: 'Расход без скидки,$',
                        value: false
                    },
                    avg_expense_rate: {
                        label: 'Ср.курс расхода',
                        value: false
                    },
                    expense_with_discount_usd: {
                        label: 'Расход со скидкой,$',
                        value: true
                    },
                    discount_usd: {
                        label: 'Сумма скидки,$',
                        value: false
                    },
                    leads_count: {
                        label: 'Кол-во лидов',
                        value: false
                    },
                    lead_rate_usd: {
                        label: 'Ставка,$',
                        value: false
                    },
                    lead_rate: {
                        label: 'Ставка в исходной валюте',
                        value: false
                    },
                    revenue: {
                        label: 'Доход в исходной валюте',
                        value: false
                    },
                    lead_currency: {
                        label: 'Валюта исходного дохода/ставки',
                        value: false
                    },
                    revenue_usd: {
                        label: 'Доход,$',
                        value: true
                    },
                    avg_revenue_rate: {
                        label: 'Ср.курс дохода',
                        value: false
                    },
                    profit: {
                        label: 'Прибыль,$',
                        value: true
                    },
                    roi: {
                        label: 'ROI,%',
                        value: true
                    },
                    gm_rev: {
                        label: 'GM/REV,%',
                        value: true
                    },
                    revenue_conversions: {
                        label: 'Ревенью в исходной валюте',
                        value: false
                    },
                    revenue_conversions_usd: {
                        label: 'Ревенью,$',
                        value: false
                    },
                    gm: {
                        label: 'GM,$',
                        value: false
                    }
                }
            }
        },
        beforeMount() {
            this.useSavedFilters = true

            let n = new Date();

            this.range = {
                startDate: new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1)),
                endDate: new Date()
            };
            this.applyFields();

            if (this.$currentUser.role == 'leader') {
                this.getLeaderUsers()
            } else if (this.$currentUser.role == 'admin') {
                this.getUsers()
            }

            this.getGroups();
            this.getSources();
            this.getOffersForSelect();
            this.getCurrency();
            this.getTrackers();
            this.getPlatforms();
            this.getAffisePlatforms();
            this.getAdvertisers();
            this.getActiveSalesManagers();
            this.getActiveAccountManagers()
            this.getTemplates();
            this.setFilters();
            this.getUserGroups();

            this.getReports();
        },
        created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
    }
</script>
<style>
    .btn i {
        text-align: center !important;
    }

    #dropdown-form ul {
        transform: inherit !important;
        background-color: white !important;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        height: 35px;
    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        height: 35px;
    }

    .mainButton {
        width: 100%;
    }

    .date {
        width: 100%;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .myOffers {
        padding-top: 4px;
    }

    .geoComponent .vs__search {
        margin: 2px 0 0;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .reportrange-text {
        font-size: 0.9rem;
        min-width: 150px;
        width: 110%!important;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 992px) {
        .input-date {
            width: 195px !important;
        }
    }

    @media (min-width: 1200px) {
        .myOffers {
            max-width: 14.66666667% !important;
        }

        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }

        .myOffers {
            max-width: 12.66666667% !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }

        .myOffers {
            max-width: 11.66666667% !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }

        .myOffers {
            max-width: 9.66666667% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/CustomReport.vue